import { Box } from '@modusign/design-system';

function RecommendedBadge() {
  return (
    <Box
      backgroundColor="statusBackgroundPrimaryBase"
      borderRadius="10px"
      color="textNeutralSlightlyLight"
      display="inline-block"
      fontSize="10px"
      fontWeight="medium"
      height="20px"
      p="5px 0px 5px"
      textAlign="center"
      width="30px"
    >
      권장
    </Box>
  );
}

export default RecommendedBadge;
